import React, { useEffect, useState, useRef, useContext } from "react";
import { formatDay } from '../../../../utils';
import { CardTag, RedDot, StopWatch, UserThumbnails } from '../../../../components';
import { content_groupActions } from '../../../../actions';
import { connect, useDispatch, useSelector } from "react-redux";
import {
  ContentLabel
} from '../../../../components';
import { WorkspaceShowContext } from "../../../../contexts/WorkspaceShowContext";
import { DraftCommentIcon } from "../../../../components";
import { hasDraft } from "../../../../utils/isDraftHasValue";
import { ContentGroupSettings } from "../../../../components/content_group_settings";
import useIsCardVisited from "../../../../hooks/useIsCardVisited";

function MobileEventCalendarCard(props) {
  const {
    workspace_id,
    can_access_edit_label,
    labelDrpdwnContainerRef,
    showLabelDrpdwn,
    setShowLabelDrpdwn,
    event
  } = props;
  const dispatch = useDispatch();
  let drpdwnContainerRef = useRef();
  const { can_access_clone_content_group, can_access_content_destroy, can_access_content } = useSelector(state => state.work_space);

  const {
    handleOpenContentGroupPopUp,
    handleOpenLabelDrpdwn,
    organization_id
  } = useContext(WorkspaceShowContext);

  const {
    isCardVisited
  } = useIsCardVisited();

  const handleLabelDelete = (label_id, e) => {
    e.stopPropagation();

    let requestParams = { label_id: label_id, assigned: false }
    let callback = () => {}
    let content_popup_notification = undefined;

    dispatch(content_groupActions.assignContentLabelToContentGroup(workspace_id, event?.id, requestParams, content_popup_notification, callback))
  }

  const handleClickLabel = (event) => {
    if(!can_access_edit_label){
      return;
    }
    let target_position = drpdwnContainerRef.current?.getBoundingClientRect();

    handleOpenLabelDrpdwn(drpdwnContainerRef.current, event.id, event?.labels, labelDrpdwnContainerRef, showLabelDrpdwn, setShowLabelDrpdwn)
  }

  const has_draft = hasDraft(event?.drafts || []);
  const has_unread_comments = event?.unread_comments?.team || event?.unread_comments?.guest;
  const name_style = has_draft ? { maxWidth: `calc(100% - 20px)`} : {}

  return (
    <div
      className="mobile-calendar_card w-100 mb-3"
      key={'mobile-calendar_event' + event.id}
    >
      <div className="d-flex justify-content-between mb-1">
        <div className="mobile-calendar_card-info">
          {
            event?.stage?.enable_timestamp &&
              <div className="d-flex align-items-center">
                <UserThumbnails 
                  users={event?.timestamp_info?.users || []}
                  openSummary={true}
                  workspace_id={workspace_id}
                  organization_id={organization_id}
                  size={'small'}
                  className={'mt-1'}
                />
                <StopWatch
                  initialTime={event?.timestamp_info?.latest_change_total_seconds || 0}
                  initialStartDate={event?.timestamp_info?.latest_start}
                  isActive={event?.stage?.enable_timestamp && event?.timestamp_info?.active}
                  viewMode={'LIST'}
                />
              </div>
          }
          <CardTag
            completed={event?.completed}
            due_date={event?.due_date}
            reminder_in_day={event?.reminder_in_day}
            can_access_content={can_access_content}
            workspace_id={workspace_id}
            card_id={event?.id}
          />

          <div className="d-flex align-items-center justify-content-between">
            <div
              className="mobile-calendar_card-title cursor-pointer d-flex align-items-center"
              onClick={() => handleOpenContentGroupPopUp(event.id)}
            >
              <div 
                className={`${isCardVisited(event?.id) ? 'text-blue' : '' } truncate`}
                style={name_style}
              >
                {event.name}
              </div>

              <RedDot className={`mx-1 ${has_unread_comments ? '' : 'd-none'}`} />
              {
                has_draft &&
                <DraftCommentIcon className={'ml-2'}/>
              }

              {
                (can_access_clone_content_group || can_access_content_destroy) &&
                  <ContentGroupSettings 
                    workspace_id={workspace_id} 
                    content_group_id={event?.id} 
                    stage_id={event?.stage?.id} 
                    can_clone={can_access_clone_content_group} 
                    can_destroy={can_access_content_destroy} 
                  />
              }

            </div>
          </div>
        </div>
            

        <div className="mobile-calendar_card-dueDate">
          {
            formatDay(event.due_date, 'hh:mm a')
          }
        </div>
      </div>

      <div
        className=""
        ref={drpdwnContainerRef}
      >
        {
          event.labels.map((label, index) => (
            <ContentLabel
              onClick={() => handleClickLabel(event)}
              id={label.id}
              name={label.name}
              editable={can_access_edit_label}
              color_hex={label.color_hex}
              handleDelete={handleLabelDelete}
              sharesPopup
            />
          ))
        }
      </div>
    </div>
  );
}


const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {  })(MobileEventCalendarCard);
